import React from 'react';
const Button = React.lazy(() => import('@material-ui/core/Button'));
const Grid = React.lazy(() => import('@material-ui/core/Grid'));
import {StandartInput} from '@components/form/StandartInput';
const ResponsiveComponent = React.lazy(() => import('@components/form/ResponsiveComponent'));
import {SimpleDialog} from "@components/form/SimpleDialog";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import AddCircleRoundedIcon from "@material-ui/icons/AddCircleRounded";
import {LabelButton} from "@components/common/buttons/LabelButton";
import {TooltipButton} from "@components/common/buttons/TooltipButton";
const merge = require('deepmerge');
import clsx from "clsx";

export class NewCategoryComponent extends React.Component {
    initState = {
        form: {
            name: "",
            status: 1,
        },
        errors: {}
    };
    state = {
        open: false,
        ...this.initState
    }

    async componentDidUpdate(prevState, prevProps) {
        if (this.props.categoryId && this.state.open && this.state.open != prevProps.open) {
            const data = await this.props.getCategoryDetails(this.props.categoryId);
            this.setState({form: merge(this.state.form, data.data)});
        } else if (this.state.open != prevProps.open) {
            this.setState(this.initState)
        }
    }

    updateCategory = async () => {
        let response = await this.props.updateCategory(
            this.props.categoryId,
            this.state.form,
        );
        if (response.errors && Object.keys(response.errors).length) {
            this.setState({errors: response.errors});
        } else {
            if (response.data) { //success
                this.setState({open: false});
                if (this.props.tableRef)
                    this.props.tableRef.current.onQueryChange();
                else this.props.onSubmitRedirect(response.data);
            }
        }
    };

    render() {
        let { classes } = this.props;

        return (
            <SimpleDialog
                fullWidth={true}
                maxWidth={'sm'}
                open={this.state.open}
                onClose={(e) => this.setState({open: false})}
                title={this.props.categoryId
                    ? <ResponsiveComponent xs='Редактирование категории' sm='Редактирование существующей категории' />
                    : <ResponsiveComponent xs='Добавление категории' sm='Добавление новой категории' />}
                icon={this.props.customOpenButton
                    ? <span onClick={e => this.setState({open : true})}>{this.props.customOpenButton}</span>
                    : this.props.categoryId
                        ? <TooltipButton title="Редактировать"
                            icon={<EditOutlinedIcon
                                color={'primary'}
                                style={{marginLeft: 'auto'}}
                            />}
                            onClick={(e) => this.setState({open: true})}
                        />
                        : <LabelButton
                            title={'Добавить категорию'}
                            icon={<AddCircleRoundedIcon color={'primary'}/>}
                            onClick={(e) => this.setState({open: true})}
                            disableMargin
                        />}
                actions={[
                    (<Button
                        onClick={(e) => this.updateCategory()}
                        id={ this.props.categoryId ? 'category_action_update' : 'category_action_create' }
                        color="primary" variant="contained"
                    >
                        Сохранить
                    </Button>),
                ]}
            >
                <Grid container spacing={3} className={classes.gridContainer}>
                    <Grid item xs={12}>
                        <StandartInput
                            name={'name'}
                            value={this.state.form.name}
                            errors={this.state.errors}
                            className={clsx([
                                classes.input,
                                classes.resetInputMarginTop,
                                classes.resetMarginBottom,
                            ])}
                            label="Название категории"
                            onChange={({target: {value}}) => this.setState(merge(this.state, {form: {name: value}}))}
                            variant={'outlined'}
                            margin={'normal'}
                            size={'small'}
                            fullWidth
                        />
                    </Grid>
                </Grid>
            </SimpleDialog>
        );
    }
}
